import Vue from 'vue';

const filters = {

  // 人工复核
  filterManualReview: {
    '-': '-',
    '-1': '无',
    0: '有额度通过',
    1: '拒绝',
    2: '驳回',
    3: '无额度通过',
    4: '等待人工复核'
  },

  // 允许发送
  fiterLetThrough: {
    '-': '-',
    0: '是',
    1: '否',
    2: '-',
  },

  // 批复状态
  filterResultCode: {
    '': '-',
    '-': '-',
    'N1': '-',
    'P1': '通过',
    'W1': '待批复',
    'K1': '拒绝'
  },

  // 商户用户状态
  filterMerUserState: {
    '-': '-',
    0: '未激活',
    1: '正常',
    2: '黄名单',
    3: '黑名单',
    4: '账户停用(风控执行人为操作)'
  },

  // 供应商用户状态
  filterSupUserState: {
    '-': '-',
    1: '正常',
    2: '未激活',
    3: '黄名单',
    4: '停用',
    9: '风控执行永久停用(人为操作)'
  },

  // 支付方式
  filterPaymentWay: {
    null: '-',
    '-': '-',
    1: '微信',
    2: '支付宝',
    3: '云闪付',
    4: '京东',
    5: 'POS'
  },

  // 通讯方式
  filterCommunicationSt: {
    null: '-',
    '-': '-',
    1: 'VPN',
    2: '普通',
  },

  // 通道类型
  filterChannelType: {
    null: '-',
    '-': '-',
    1: '银行',
    2: '第三方支付公司',
  },

  // 通道来源
  filterSourceChannelType: {
    null: '-',
    '-': '-',
    1: '渠道自有第三方通道',
    2: '盈众自有通道',
  },

  // 支付状态
  filterPaymentState: {
    '-': '-',
    0: '待支付',
    1: '交易成功',
    2: '交易失败',
    3: '退款成功',
    4: '退款失败'
  },

  // 交易状态
  filterState: {
    '-': '-',
    0: '待支付',
    1: '交易成功',
    2: '交易失败',
    3: '远期账单待确认(供应商确认)',
    4: '远期账单待退款',
    5: '退款成功',
    6: '退款失败',
    7: '远期账单待结算(商户确认)'
  },

  // 清算状态
  filterSettleState: {
    '-': '-',
    '-1': '等待清算',
    0: '发起清算',
    1: '清算成功',
    2: '清算失败'
  },

  // 交易类型
  filterTradeType: {
    '-': '-',
    1: '即时',
    2: '远期'
  },

  // 交易方式
  filterTradeWay: {
    '-': '-',
    1: '额度交易',
    2: '银行卡交易',
    3: '余额交易'
  },

  // 是否
  filterIsState: {
    '-': '-',
    0: '是',
    1: '否'
  },

  // 触发对象
  filterTargetType: {
    '-': '-',
    1: '商户',
    2: '供应商',
    3: '黄名单的商户',
    4: '黄名单的供应商'
  },

  // 审核状态
  filterAuditState: {
    '-': '-',
    null: '-',
    // '-2': '自动审核不通过',
    // '-1': '首次渠道不通过',
    1: '待系统审核',
    2: '审核通过待发行',
    3: '等待受理复核',
    4: '受理复核未通过',
    5: '拒绝进件（已释放）',
    6: '拒绝进件（待释放）',
    7: '发行通过待激活',
    8: '已激活',
    // 9: '已激活'
  },

  // T1 服务商查询 审核状态
  filterApprovalStatus: {
    '-': '-',
    null: '-',
    0: '待总部审核',
    1: '总部审核通过(待配置）',
    2: '总部拒绝',
    4: '正常',
    7: '冻结',
    8: '合同已到期'
  },

  // 发行状态
  filterIssuedState: {
    null: '--',
    '': '--',
    0: '等待总部审核',
    1: '总部通过(等待渠道审核)',
    2: '总部驳回',
    3: '总部拒绝',
    // 4: '渠道不通过(资料问题导致等)',
    5: '渠道拒绝(无法重新申请)',
    6: '渠道审核通过（等待发卡)',
    7: '转移发行',
    8: '发卡-未激活',
    9: '发卡已激活(正常)',
    12: '等待人工复核',
    13: '人工复核有额度通过(等待渠道审核)',
    14: '人工驳回',
    15: '人工拒绝',
    16: '人工复核无额度通过',
    // 17: '无额度转移发行',
    18: '无额度发行成功',
    19: '额度激活中',
    20: '激活失败'
  },

  // 历史审批
  filterHistoryCheck: {
    null: '-',
    '': '-',
    1: '无',
    2: '人工驳回',
    3: '渠道拒绝'
  },

  // 受理复核
  review: {
    0: '等待受理复核',
    1: '通过',
    2: '拒绝进件（待释放）',
    3: '拒绝进件（已释放）',
    4: '驳回申请',
    5: '-'
    // '': '-',
    // 1: '拒绝',
    // 2: '驳回',
    // 3: '通过'
  },


}

for (let filter in filters) {
  Vue.filter(filter, (value) => filters[filter][value])
}
